import 'javascripts/portal_consorcio';
import 'stylesheets/portal_consorcio';